import "./cookie-banner.component.scss"

export class CookieBannerComponent {
    static #attrAcceptCookie = "[data-accept-cookie]";
    static #cookieKey = "cookiesAccepted"
    static cookieBannerElement = document.getElementById("cookie-banner");
    static cookiesAccepted = !!localStorage.getItem(this.#cookieKey);

    static init() {
        if (!this.cookiesAccepted) {
            this.cookieBannerElement.classList.add("is-active");
        } else {
            this.cookieBannerElement.style.display = "none";
        }

        this.cookieBannerElement.addEventListener("click", (eve)=> {
            if (eve.target.matches(this.#attrAcceptCookie)) {
                this.acceptCookies();
            }
        })

    }

    static acceptCookies() {
        localStorage.setItem(this.#cookieKey, "true");
        this.cookiesAccepted = true;
        this.cookieBannerElement.classList.remove("is-active");
        setTimeout(() => {
            this.cookieBannerElement.style.display = "none";
        }, 1000);
    }

}